import { render, staticRenderFns } from "./exercises-test-preview.vue?vue&type=template&id=cb7d90f8"
import script from "./exercises-test-preview.vue?vue&type=script&lang=js"
export * from "./exercises-test-preview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports